import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { Select } from "@blueprintjs/select";
import { 
  Button, MenuItem, Alert, Intent, Divider
} from '@blueprintjs/core';
import Pagination from 'components/Pagination';
import Footer from 'components/Footer';
import Toast from 'helpers/toaster';
import moment from 'moment';
import { formatTimeOnly, formatDateOnly } from 'helpers/time';
import TableCellWithSubtext from 'components/Tables/TableCellWithSubtext';

@inject('store', 'clientStore', 'bookingStore', 'viewStore') @observer
class BookingTable extends Component {
  @observable isOpenAddEquipmentDialog = false;
  @observable isDeleteDialogVisible = false;
  @observable service;

  onPaginationChange(newPage) {
    let {
      viewStore: {
        bookingSearch
      }
    } = this.props;
    this.props.viewStore.bookingSearch = {
      ...bookingSearch,
      page: newPage
    };
    this.props.viewStore.bookings();
  }

  handleDeleteCancel() {
    this.isDeleteDialogVisible = false;
  }

  handleDeleteConfirm() {
    this.isDeleteDialogVisible = false;
    this.props.bookingStore.deleteBooking(this.service)
      .then(this.onSuccessfulDeleteBooking.bind(this))
      .catch(this.onFailDeleteBooking.bind(this))
  }

  onSuccessfulDeleteBooking(response) {
    Toast.show({ icon: 'thumbs-up', message: 'booking deleted successfully!', intent: Intent.SUCCESS })
    this.service = null;
    this.isDeleteDialogVisible = false;
  }

  onFailDeleteBooking(error) {
    this.isDeleteDialogVisible = false;
    Toast.show({ icon: 'warning-sign', message: 'Unable to delete booking!', intent: Intent.DANGER })
  }

  handleServiceTypeClick(event, service) {
    switch (event.label) {
      case 'Edit':
        this.service = service;
        this.props.viewStore.bookingShow({uuid: service.attributes.id})
        break;
      case 'Delete':
        this.isDeleteDialogVisible = true;
        this.service = service;
        break;
      default:
    }
  }

  render() {
    let {
      viewStore,
      bookingStore: {
        bookings: {
          objects,
          meta
        }
      }
    } = this.props;

    if (objects.length === 0) {
      return (
        <div className="bp3-callout bp3-icon-info-sign warning-alert-message bp3-intent-warning">
          <h4 className="bp3-heading">No Results</h4>
          Your search criteria returned no results. Please modify/expand your search parameters to see results.
        </div>
      )
    }
    return (
      <React.Fragment>
        <Footer>
          <div className="bp3-navbar-group bp3-align-left">
            <Pagination
              value={meta.page}
              total={meta.total_pages}
              onChange={this.onPaginationChange.bind(this)}
            />
          </div>
        </Footer>
        <div className="card rounded-0 table-responsive">
          <table className="table table-width table-data-presentation table-hover">
            <thead>
              <tr>
                <th width="15%">Service Date</th>
                <th>Customer Details</th>
                <th>Address</th>
                <th>Status</th>
                <th className="item-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {
                objects.map((booking) => {
                  return (
                    <tr key={booking.id}>
                      <td>
                        <TableCellWithSubtext
                          mainText={formatDateOnly(booking.attributes.start_date)}
                          subText={`${formatTimeOnly(booking.attributes.start_date)}`}
                        />
                        {/* {moment(booking.attributes.start_date).format('MMMM Do YYYY, h:mm:ss a')} */}
                      </td>
                      <td>
                        <TableCellWithSubtext
                          mainText={ `${booking.attributes.first_name } ${booking.attributes.last_name }`}
                          subText={ `${booking.attributes.email }, ${booking.attributes.phone}`}
                        />
                      </td>
                      <td>{booking.attributes.address}</td>
                      <td>
                        {booking.attributes.status === 'draft' &&
                          <span className="bp3-tag bp3-interactive capitalize">{booking.attributes.status}</span>}

                        {booking.attributes.status === 'confirmed' &&
                          <span className="bp3-tag bp3-interactive capitalize bp3-intent-success">{booking.attributes.status}</span>}
                      </td>
                      <td>
                        <div className="action-buttons" minimal={'true'}>
                          <Button title="Edit" minimal={true} small={true} onClick={() => viewStore.bookingShow({uuid: booking.attributes.id})}>
                            <img src="/edit-light-icon.svg"/>
                          </Button>
                          <Divider/>
                          <Button title="Delete" minimal={true} small={true} onClick={() => this.handleServiceTypeClick({ label: 'Delete' }, booking)}>
                            <img src="/delete-light-icon.svg" />
                          </Button>
                        </div>
                    </td>                      
                  </tr> 
                  )
                })
              }
            </tbody>
          </table>
        </div>
        <Alert
          cancelButtonText="Cancel"
          confirmButtonText="Delete"
          icon="trash"
          intent={Intent.DANGER}
          isOpen={this.isDeleteDialogVisible}
          onCancel={this.handleDeleteCancel.bind(this)}
          onConfirm={this.handleDeleteConfirm.bind(this)}
        >
          <p>Warnning! Deleting this booking will not be recoverable.</p>
          <p>Are you sure you want to do this?</p>
        </Alert>

        <Footer>
          <div className="bp3-navbar-group bp3-align-left">
            <Pagination
              value={meta.page}
              total={meta.total_pages}
              onChange={this.onPaginationChange.bind(this)}
            />
          </div>
        </Footer>

      </React.Fragment>
    )
  }

}

export default BookingTable;